export default __webpack_public_path__ + "static/media/7UM515.a912bda4.jpg";